import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../../../../../shared/components';
import { ProjectsService } from '../../../../core/projects.service';

@Component({
    selector: 'app-rfis-submittals-combined',
    templateUrl: './rfis-submittals-combined.component.html',
    styleUrls: ['./rfis-submittals-combined.component.scss'],
    standalone: false
})
export class RfisSubmittalsCombinedComponent implements OnInit {
  @Input() rfisData: any[] = [];
  @Input() submittalsData: any[] = [];
  @Input() projectId = '';

  rfiOpenCount = 0;
  rfiClosedCount = 0;
  submittalOpenCount = 0;
  submittalClosedCount = 0;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private projectsService: ProjectsService,
  ) {}

  ngOnInit(): void {
    // Calculate RFI counts
    if (this.rfisData?.length) {
      this.rfisData.forEach(obj => {
        const count = Number(obj['rfi_count']) || 0;
        if (obj.status === 'closed') {
          this.rfiClosedCount += count;
        } else if (obj.status !== 'draft') {
          this.rfiOpenCount += count;
        }
      });
    }

    // Calculate Submittal counts
    if (this.submittalsData?.length) {
      this.submittalsData.forEach(obj => {
        const count = Number(obj['submittal_count']) || 0;
        if (obj.status === 'submitted' || obj.status === 'sent_for_review') {
          this.submittalOpenCount += count;
        } else if (obj.status !== 'draft') {
          this.submittalClosedCount += count;
        }
      });
    }
  }

  get totalOpen(): number {
    return this.rfiOpenCount + this.submittalOpenCount;
  }

  get totalClosed(): number {
    return this.rfiClosedCount + this.submittalClosedCount;
  }

  get hasData(): boolean {
    return this.totalOpen > 0 || this.totalClosed > 0;
  }

  private closeAndNavigate(queryParams: Record<string, any>): void {
    this.projectsService.isAnyFormDirty.next(false);
    this.projectsService.closeRightPanel.next();
    this.router.navigate([`/projects/${this.projectId}`], { queryParams });
  }

  private tryCloseAndNavigate(queryParams: Record<string, any>): void {
    const isFormDirty = this.projectsService.isAnyFormDirty.getValue();
    if (!isFormDirty) {
      this.closeAndNavigate(queryParams);
      return;
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: new ConfirmDialogModel(
        'Unsaved changes',
        'There are unsaved changes.<br/>Are you sure you want to discard?',
      ),
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.closeAndNavigate(queryParams);
      }
    });
  }

  handleRfiClick(): void {
    this.tryCloseAndNavigate({
      status: ['submitted', 'sent_for_review'],
      tab: 'rfis',
    });
  }

  handleSubmittalClick(): void {
    this.tryCloseAndNavigate({
      status: ['submitted', 'sent_for_review'],
      tab: 'submittals',
    });
  }

  handleSectionClick(): void {
    this.tryCloseAndNavigate({ tab: 'submittals' });
  }
}
